import { getFullPath, routes } from "../../routes";
import { Navigate, useParams } from "react-router-dom";
import { TestResultsForm } from "./TestResultsForm";
import { useTestResults } from "../hooks";

export function TestResults() {
  const { id } = useParams();
  const { data, isLoading, isError } = useTestResults(id);

  if (isLoading) {
    return <p>Loading...</p>;
  } else if (isError) {
    return <p>An unknown error occurred.</p>;
  } else if (data) {
    return <TestResultsForm results={data} />;
  } else {
    return <Navigate to={getFullPath(routes.testEvent.create)} />;
  }
}
